import axios from 'axios'
import { Message } from 'element-ui'

const service = axios.create({
    baseURL: '/api',
    timeout: 35000
})

service.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token')
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    error => Promise.reject(error)
)

service.interceptors.response.use(
    response => {
        const res = response.data
        console.log(res)
        if (res.code === 401) {
            Message.error('登录已失效，请重新登录')
            localStorage.clear()
            window.location.href = '/admin/login'
            return Promise.reject(new Error(res.message || '未认证'))
        }
        if (res.code === 200) return res.data  // 只返回 data 部分

        Message.error(res.message || '请求失败')
        return Promise.reject(new Error(res.message || '请求失败'))
    },
    error => {
        const status = error.response?.status
        if (status === 401) {
            Message.error('登录已失效，请重新登录')
            localStorage.clear()
            window.location.href = '/admin/login'
        } else {
            Message.error('网络或服务器异常')
        }
        return Promise.reject(error)
    }
)

// 只导出函数，不用 export default
export function get(url, params) {
    return service({ url, method: 'get', params })
}

export function post(url, data) {
    // 如果是 FormData，不设置 Content-Type，让 axios 自动处理
    if (data instanceof FormData) {
        return service({
            url,
            method: 'post',
            data,
            headers: {} // 不设置 Content-Type
        })
    }
    return service({ url, method: 'post', data })
}

export function put(url, data) {
    return service({ url, method: 'put', data })
}

export function del(url, data) {
    return service({ url, method: 'delete', data })
}
